<template>
	<div class="lulo-pro-view">
    <navigation ref="navigation" />
		<header-section 
			class="lulo-pro"
			:appCustomLink="content.app_custom_link"
			:subtitle="content.introduction"
			:link_text="content.link_text"
			:fullScreen="content.full_screen"
			:videoUrl="content.media.data ? getAssetUrl(content.media.data.attributes.url) : ''"
		/>
		<div v-for="(c,i) in content.content" :key="i" class="block">
			<pro-splited-form-block
				v-if="c.__component == 'features.splited-form' && c.media"
				:imgUrl="c.media.data.attributes.ext == '.jpg' || c.media.data.attributes.ext == '.png' ? getAssetUrl(c.media.data.attributes.url) : null"
				:videoUrl="c.media.data.attributes.ext == '.mp4' || c.media.data.attributes.ext == '.gif' ? getAssetUrl(c.media.data.attributes.url) : null"
				:title="c.title"
        :description="c.description"
        :disclaimer="c.disclaimer"
			/>
			<pro-items-block
				v-if="c.__component == 'pro.cards'"
				:description="c.description"
				:items="c.content"
				:alternate="c.alternate"
			/>
			<feature-splited-image-block
				v-if="c.__component == 'features.bigtitle' && c.image"
				class="lulo-pro"
				:imgUrl="c.image.data.attributes.ext == '.jpg' || c.image.data.attributes.ext == '.png' ? getAssetUrl(c.image.data.attributes.url) : null"
				:videoUrl="c.image.data.attributes.ext == '.mp4' || c.image.data.attributes.ext == '.gif' ? getAssetUrl(c.image.data.attributes.url) : null"
				:title="c.title"
				:description="c.description"
				:titleBgColor="c.titleBgColor"
			/>
			<feature-cards-block
				v-if="c.__component == 'features.list' && c.media.data"
				class="lulo-pro"
				:imgUrl="imageFormat(c.media.data.attributes.ext) ? getAssetUrl(c.media.data.attributes.url) : null"
				:videoUrl="videoFormat(c.media.data.attributes.ext) ? getAssetUrl(c.media.data.attributes.url) : null"
				:title="c.title"
				:text="c.text"
				:cards="c.content"
				:alternate="c.alternate"
			/>
			<pro-full-list-block
				v-if="c.__component == 'pro.full-list'"
				:imgUrl="c.media && c.media.data && imageFormat(c.media.data.attributes.ext) ? getAssetUrl(c.media.data.attributes.url) : null"
				:title="c.title"
				:description="c.description"
			/>
		</div>
    <footer-section />
  </div>
</template>

<script>
// Mixins
import ViewMixin from "@/mixins/viewMixin"
// Components
import Navigation from "@/components/navigation"
import Header from "@/components/global/header"
import Footer from "@/components/global/footer"

// Components Feature
import ProSplitedFormBlock from "@/components/lulo-pro/pro-splited-form-block"
import ProItemsBlock from "@/components/lulo-pro/pro-items-block"
import FeatureSplitedImageBlock from "@/components/feature/feature-splited-image-block"
import FeatureCardsBlock from "@/components/feature/feature-cards-block"
import ProFullListBlock from "@/components/lulo-pro/pro-full-list-block"

export default {
	name:"lulo-pro",
	mixins:[ViewMixin],
	data: () => {
			return{
				content: {
					content: [],
				}
			};
	},
	components: {
		'navigation': Navigation,
		'header-section': Header,
		'footer-section': Footer,
		'pro-splited-form-block': ProSplitedFormBlock,
		'pro-items-block':ProItemsBlock,
		'feature-splited-image-block': FeatureSplitedImageBlock,
		'feature-cards-block': FeatureCardsBlock,
		'pro-full-list-block': ProFullListBlock
	},
	beforeMount() {
    this.content = this.$store.state.page["lulo-pro"].data.attributes
  },
	mounted() {
    this.show()
    this.$refs.navigation.activate("/lulo-pro")
  },
	  beforeDestroy() {
    this.$refs.navigation.forcedLight = false
  },

  methods: {
    show() {
      this.$refs.navigation.hidden = false
      this.$refs.navigation.forcedLight = true
    },
		imageFormat(rawFormat){
			switch (true) {
				case (rawFormat === '.png'):
						return 1
				case (rawFormat === '.jpg'):
						return 1
				case (rawFormat === '.jpeg'):
						return 1
				case (rawFormat === '.svg'):
						return 1
				case (rawFormat === '.gif'):
						return 1
				default:
						break;
			}
		},
	videoFormat(rawFormat){
			switch (true) {
				case (rawFormat === '.mp4'):
						return 1
				case (rawFormat === '.mpeg'):
						return 1
				default:
						break;
			}
		}
  },
}
</script>

<style lang="less">
@import "../styles/vars.less";
</style>